import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class GitService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get providers list
     * Returns Git providers available for the organization (defaults and self-hosted).
     * @returns GitProvider Providers list.
     * @throws ApiError
     */
    getGitProviders({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/git/providers', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get namespaces
     * Returns namespaces for a given connection.
     *
     * Namespace is a generic name for top level entity across different Git providers.
     * For example,
     * - in GitHub it is called "owner"
     * - in GitLab it is called "namespace"
     * - in Bitbucket Cloud it is called "workspace"
     * - in Bitbucket DataCenter/Server it is called "project"
     * - in Azure DevOps it is called "organization" (TODO: need to confirm, thanks copilot!)
     *
     * This namespace should be used for subsequent calls to get repositories, branches, etc.
     *
     * @returns Namespace Namespaces list.
     * @throws ApiError
     */
    getNamespaces({ orgId, credentialId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/git/{credentialId}/namespaces', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get repositories
     * Returns repositories list for a given connection.
     *
     * > Note: Omit `namespace` query parameter for GiLab Cloud when you use Project Access Token.
     *
     * @returns Repository Repositories list.
     * @throws ApiError
     */
    getRepositories({ orgId, credentialId, namespace, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/git/{credentialId}/repositories', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, query: {
                'namespace': namespace,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get branches
     * Returns branches list for a given repository.
     * @returns string Branches list.
     * @throws ApiError
     */
    getBranches({ orgId, credentialId, repoId, namespace, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/git/{credentialId}/branches', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, query: {
                'namespace': namespace,
                'repoId': repoId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get folders
     * Returns folders in repository for specific branch.
     * @returns string Folders list.
     * @throws ApiError
     */
    getFolders({ orgId, credentialId, repoId, branchName, namespace, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/git/{credentialId}/folders', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, query: {
                'namespace': namespace,
                'repoId': repoId,
                'branchName': branchName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Process webhook
     * Process push, PR and branch deletion events from remote repository.
     * @returns any Processed successfully.
     * @throws ApiError
     */
    processWebhook({ provider, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/webhooks/git/{provider}', path: {
                'provider': provider,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=GitService.js.map